import React from "react";
import Slider from "react-slick";
import AppFutura from "../Assets/Images/App-Futura.png";
import GoodFilms from "../Assets/Images/Good-Firms.png";
import GlobalImg from "../Assets/Images/G2.png";
import ClutchImg from "../Assets/Images/clutch.png";
import BarkImg from "../Assets/Images/bark.png";

const SimpleSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1, slidesToScroll: 1, dots: false },
      },
    ],
  };

  const logos = [AppFutura, GoodFilms, GlobalImg, ClutchImg, BarkImg];

  return (
    <div className="max-w-[1140px] mx-auto glass-card p-6 sm:p-10 lg:p-16 mt-10">
      <div className="slider-container items-center">
        <Slider {...settings}>
          {logos.map((logo, index) => (
            <div key={index} className="px-2">
              <div className="bg-white/90 rounded-xl p-3 mx-1 sm:mx-2">
                <img
                  className="w-full max-w-[200px] h-20 sm:h-24 lg:h-32 object-contain mx-auto"
                  src={logo}
                  alt=""
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SimpleSlider;
